import { render, staticRenderFns } from "./TheMainLayout.vue?vue&type=template&id=6e286ea9&scoped=true&"
import script from "./TheMainLayout.vue?vue&type=script&lang=js&"
export * from "./TheMainLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheMainLayout.vue?vue&type=style&index=0&id=6e286ea9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e286ea9",
  null
  
)

export default component.exports